import momentTz from 'moment-timezone';
import { Box, Grid, Typography } from '@mui/material';

import { FORTA_GRAY4, FORTA_GRAY2 } from '../../../utils/colors';
import TimeZoneIcon from '../../svgs/TimeZoneIcon';

import type { Moment } from 'moment';

interface ICalendarHeaderProps {
  week: [Moment, Moment, Moment, Moment, Moment, Moment, Moment];
}

function CalendarHeader({ week }: ICalendarHeaderProps) {
  const userTimezone = momentTz.tz.guess(true);
  const nowInUserTimezone = momentTz().tz(userTimezone);
  const [sun, mon, tue, wed, thu, fri, sat] = week;
  return (
    <Grid container textAlign={'center'}>
      <Grid item xs={0.8} sx={{ border: `2px solid ${FORTA_GRAY2}`, p: 1 }}>
        <Box sx={{ mt: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <TimeZoneIcon color={FORTA_GRAY4} />
          <Typography display="inline" ml={1} fontWeight={700} fontSize={14}>
            {nowInUserTimezone.format('z')}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={1.6} sx={{ border: `2px solid ${FORTA_GRAY2}`, borderLeft: 'none', p: 1 }}>
        <Box color={FORTA_GRAY4}>
          <Typography>Sun</Typography>
          <Typography fontWeight={700}>{sun?.format('D')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={1.6} sx={{ border: `2px solid ${FORTA_GRAY2}`, borderLeft: 'none', p: 1 }}>
        <Box color={FORTA_GRAY4}>
          <Typography>Mon</Typography>
          <Typography fontWeight={700}>{mon?.format('D')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={1.6} sx={{ border: `2px solid ${FORTA_GRAY2}`, borderLeft: 'none', p: 1 }}>
        <Box color={FORTA_GRAY4}>
          <Typography>Tue</Typography>
          <Typography fontWeight={700}>{tue?.format('D')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={1.6} sx={{ border: `2px solid ${FORTA_GRAY2}`, borderLeft: 'none', p: 1 }}>
        <Box color={FORTA_GRAY4}>
          <Typography>Wed</Typography>
          <Typography fontWeight={700}>{wed?.format('D')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={1.6} sx={{ border: `2px solid ${FORTA_GRAY2}`, borderLeft: 'none', p: 1 }}>
        <Box color={FORTA_GRAY4}>
          <Typography>Thu</Typography>
          <Typography fontWeight={700}>{thu?.format('D')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={1.6} sx={{ border: `2px solid ${FORTA_GRAY2}`, borderLeft: 'none', p: 1 }}>
        <Box color={FORTA_GRAY4}>
          <Typography>Fri</Typography>
          <Typography fontWeight={700}>{fri?.format('D')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={1.6} sx={{ border: `2px solid ${FORTA_GRAY2}`, borderLeft: 'none', p: 1 }}>
        <Box color={FORTA_GRAY4}>
          <Typography>Sat</Typography>
          <Typography fontWeight={700}>{sat?.format('D')}</Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default CalendarHeader;
